package com.eladfinish.bible.contest.navigation.back

/**
 * Lets a platform whose Back mechanism doesn't go through MyBackHandler — the browser's Back
 * button on web, which moves through the tab's history on its own — ask the visible screen
 * whether it takes this Back for itself (see [InterceptBackWhen]).
 *
 * Set by BibleContestApp for as long as it is composed.
 */
object PlatformBackInterception {
    /** Returns true when the visible screen consumed the Back. */
    var interceptBack: (() -> Boolean)? = null
}
